import { TDoor } from 'shared/types/doors';
import { DoorContent } from '../DoorContent';

export const FirstDoorContent: React.FC<TDoor> = props => {
  return (
    <DoorContent btnText="Забрать гайд" {...props}>
      <div>
        Вас ждёт 8 подарков. За каждым окошком — полезный инструмент для вашей работы, который поможет стартовать в
        новом году уверенно и продуктивно. Открываем первое!
      </div>
      <div>
        <div>
          <b>📘 Гайд «Декабрь и январь на максимум»</b>
        </div>
        Ваш подробный чек-лист, чтобы ярко стартовать в Новом году! Пошаговая инструкция, как провести первый месяц 2026
        продуктивно и не потерять ни одного гостя.
      </div>
      <div>
        ✨ <b>А в дополнение — 250 бонусов на продвижение</b>, чтобы ваши объекты первыми увидели все, кто начнёт
        планировать поездки в новом году.
      </div>
      <div>
        <i>
          <div>И это только первый сюрприз...</div>
          Скоро откроем новые окошки — каждый со своим полезным секретом, а пока — изучайте гайд и готовьтесь к
          активному 2026 году!
        </i>
      </div>
    </DoorContent>
  );
};
